module.exports = __webpack_public_path__ + "static/categories_import-addadb0c1703d630c2cf410ddb34a4d2.png";